import React, { Fragment, Component } from 'react'
import {
    Row, Col,Button, Label,Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"
import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'

import IndexBloc from '../../Index/Blocs/IndexBloc'
import UpdateBloc from '../../Update/Blocs/UpdateBloc'

class SyaratJabatanComponent extends Component {

    updateBloc = new UpdateBloc()
    indexBloc = new IndexBloc()
    source
    timer
    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            detailSyarat: {},
            detailPelatihan: [
                {
                    pelatihan_id: 1,
                    pelatihan_penjenjangan: '',
                    pelatihan_teknik: '',
                }
            ],
            detailPengalaman: [
                {
                    pengalaman_id: 1,
                    pengalaman_jabatan: '',
                    pengalaman_lama: '',
                }
            ],
            detailUpaya: [
                {
                    upaya_id: 1,
                    upaya_jenis: '',
                    upaya_frekuensi: '',
                }
            ],
            detailInterest: [
                {
                    interest_id: 1,
                    interest_name: '',
                }
            ],
            dataForm: {},
            isLoading: 0,
        }
    }


    reformatPelatihan = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["pelatihan_id"] = data.requisite_training_id;
          newObj["pelatihan_penjenjangan"] = data.requisite_training_name;
          newObj["pelatihan_teknik"] = data.requisite_training_technique;
          return newObj;
        });
    }
    reformatPengalaman = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["pengalaman_id"] = data.requisite_experience_id;
          newObj["pengalaman_jabatan"] = data.requisite_experience_nama;
          newObj["pengalaman_lama"] = data.requisite_experience_durasi;
          return newObj;
        });
    }
    reformatUpaya = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["upaya_id"] = data.requisite_training_id;
          newObj["upaya_jenis"] = data.requisite_training_name;
          newObj["upaya_frekuensi"] = data.requisite_training_frequency;
          return newObj;
        });
    }
    reformatInterest = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["interest_id"] = data.requisite_interest_id;
          newObj["interest_name"] = data.requisite_interest_name;
          return newObj;
        });
    }
 

    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }

    loadDetailSyaratJabatan = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchRequisite(query)
    }
    loadPelatihan = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchTraining(query)
    }
    loadDetailPengalaman = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchExperience(query)
    }
    
    loadInterest = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchInterest(query)
    }

    componentDidMount() {
        this.loadDetailSyaratJabatan()
        this.loadDetailPengalaman()
        this.loadPelatihan()
        this.loadInterest()
        // console.log(this.state.detailTanggungjawab)
        
        this.updateBloc.detailPossesionRequisiteChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log('syarat jabatan')
                        if (response != null) {
                            console.log(response)
                            this.setState({ detailSyarat: response })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.detailTrainingChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        if (response.length > 0) {
                            this.setState({ detailPelatihan: this.reformatPelatihan(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.detailPengalamanChannel.subscribe((result) => {
            // console.log('Pengalaman', result)
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        if (response.length > 0) {
                            this.setState({ detailPengalaman: this.reformatPengalaman(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.detailUpayaChannel.subscribe((result) => {
            // console.log('Upaya', result)
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        if (response.length > 0) {
                            this.setState({ detailUpaya: this.reformatUpaya(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.detailInterestChannel.subscribe((result) => {
            // console.log('Upaya', result)
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        if (response.length > 0) {
                            this.setState({ detailInterest: this.reformatInterest(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        
        


    }

    componentWillUnmount() {
        this.updateBloc.positionInfoChannel?.unsubscribe()
        this.updateBloc.detailTanggungjawabChannel?.unsubscribe()
    }

    render() {
        
        return (
            <Fragment>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmitSyarat(e, values)}
                >
                    <Col md="12">
                            <div className="row" style={{padding:'10px'}}>
                                <div className="col-md-5">
                                    <b>Syarat Jabatan</b>
                                    {/* <p>Setiap yang bertanda () Wajib Diisi</p> */}
                                </div>
                            </div>
                            <hr/>
                        </Col>
                    <Row className="mb-12">
                        <div>
                            <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Pangkat Golongan 
                                </label>
                                <Col md="9">
                                    {this.state.detailSyarat.requisite_pangkat}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Jenis Pendidikan 
                                </label>
                                <Col md="9">
                                    {this.state.detailSyarat.requisite_pendidikan}
                                </Col>
                            </Row>
                        </div>
                            <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Kursus/Pelatihan{/*   */}
                                </label>
                                <Col md="9">
                                   
                                </Col>
                            </Row>
                    {this.state.detailPelatihan.map((data, index) => {
                        return (
                        <div>
                            <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Penjenjangan 
                                </label>
                                <Col md="9">
                                    {data.pelatihan_penjenjangan}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Teknik 
                                </label>
                                <Col md="9">
                                    {data.pelatihan_teknik}
                                </Col>
                                
                                
                            </Row>
                            <hr />
                        </div>
                            )    
                        })
                    }
                    <div>
                        
                    {this.state.detailPengalaman.map((data, index) => {
                        return (
                        <div>
                        <Row className="mb-3">
                            <label
                                htmlFor="fielCode"
                                className="col-md-2 col-form-label"
                            >
                            Pengalaman Kerja
                            </label>
                            <Col md="9">
                                
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <label
                                htmlFor="fielCode"
                                className="col-md-2 col-form-label"
                            >
                            Jabatan 
                            </label>
                            <Col md="9">
                                {data.pengalaman_jabatan}
                            </Col>
                        </Row>
                        <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Lama 
                                </label>
                                <Col md="9">
                                    {data.pengalaman_lama}
                                </Col>
                            </Row>
                            </div>
                            )    
                        })
                    }
                    <hr />
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        Kondisi Fisik 
                        </label>
                        <Col md="9">
                            {this.state.detailSyarat.requisite_kondisi_fisik}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        Jenis Kelamin 
                        </label>
                        <Col md="9">
                            {this.state.detailSyarat.requisite_jenis_kelamin}
                        </Col>
                    </Row>
                    <hr />
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        Bakat 
                        </label>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        G(Intelegensia) 
                        </label>
                        <Col md="9">
                           {this.state.detailSyarat.requisite_bakat_intelegensia}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        V(Verbal) 
                        </label>
                        <Col md="9">
                            {this.state.detailSyarat.requisite_bakat_verbal}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        P(Pencerapan Bentuk) 
                        </label>
                        <Col md="9">
                            {this.state.detailSyarat.requisite_bakat_penyerapan_bentuk}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        Q(Ketelitian) 
                        </label>
                        <Col md="9">
                            {this.state.detailSyarat.requisite_bakat_ketelitian}
                        </Col>
                    </Row>
                </div>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        Minat
                        </label>
                        <Col md="9">
                            
                        </Col>
                    </Row>
                {
                    this.state.detailInterest.map((data, index) => {
                        return (
                    <div>
                        <Row className="mb-3">
                            <label
                                htmlFor="fielCode"
                                className="col-md-2 col-form-label"
                            >
                            {/* Jenis Upaya  */}
                            </label>
                            <Col md="9">
                                {data.interest_name}
                            </Col>
                        
                            
                        </Row>
                    </div>
                    )    
                })
            }
                    
                        
                        <AvField
                            name="position_uuid"
                            type="hidden"
                            value={this.props.uuid}
                            // validate={{ required: { value: true } }}
                            readOnly={true}
                        />
                        
                    </Row>
                    <Row className="mb-3" style={{padding:'25px'}}>
                        <Col md="3"></Col>
                        <Col md="9">
                            <Link to="/master/syarat_jabatan.html">
                                <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                            </Link>
                            {' '}
                            
                        </Col>
                    </Row>
                </AvForm>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    null// <Redirect to='/master/syarat_jabatan.html'/>
                : null }
            </Fragment>
        )
    }


}

export default SyaratJabatanComponent
